import { ComponentType, lazy, LazyExoticComponent } from 'react';

export function namedLazy<Component extends ComponentType<any>, Name extends string>(
  factory: () => Promise<Record<Name, Component>>,
  name: Name,
): LazyExoticComponent<Component> {
  return lazy(() => factory().then((mod) => ({ default: mod[name] })));
}
